import {Routes} from '@angular/router';

export const routes: Routes = [
  {
    path: '', loadComponent: () => import('../frontend-shell/frontend-shell').then(m => m.FrontendShell), children: [
      {path: '', loadComponent: () => import('../home/home').then(m => m.Home)},
      {path: 'cause/:id/:ref', loadComponent: () => import('../cause-page/cause-page').then(m => m.CausePage,)},
      {path: 'cause/:id', loadComponent: () => import('../cause-page/cause-page').then(m => m.CausePage,)},
      {path: 'causes', loadComponent: () => import('./cause-list-page/cause-list-page').then(m => m.CauseListPage)},
      {path: 'about-us', loadComponent: () => import('./about-us-page/about-us-page').then(m => m.AboutUsPage)},
      {path: 'contact-us', loadComponent: () => import('./contact-us-page/contact-us-page').then(m => m.ContactUsPage)},
      {path: 'form/pad-daan', loadComponent: () => import('../paddaan/paddaan').then(m => m.Paddaan,)},
      {
        path: 'payment/status/success',
        loadComponent: () => import('../app/payment-status/payment-status').then(m => m.PaymentStatus)
      }, {
        path: 'payment/status/cancel',
        loadComponent: () => import('../app/payment-cancel/payment-cancel').then(m => m.PaymentCancel)
      },
      {path: 'terms-of-service', loadComponent: () => import('./terms-page/terms-page').then(m => m.TermsPage)},
      {
        path: 'privacy-policy',
        loadComponent: () => import( './privacy-policy-page/privacy-policy-page.component').then(m => m.PrivacyPolicyPage)
      }, {
        path: 'cookie-policy',
        loadComponent: () => import('./cookie-page/cookie-page').then(m => m.CookiePage)
      }, {
        path: 'our-mission',
        loadComponent: () => import('./static-pages/mission-page/mission-page').then(m => m.MissionPage)
      },

    ]
  }
];
